/* NORTHSHEEP — the basket page's checkout lock follows the basket.

   "Nothing but brushes" and "more fillings than cushions" turn Checkout off and
   hide the express buttons (sections/main-cart-footer.liquid, ns-brush-only,
   ns-filling-check). That part of the footer sits outside the `.js-contents`
   Dawn redraws after a change, and the express buttons (PayPal, Shop Pay) can
   only be drawn by a full page: so a basket emptied of its sheepskin could
   still check out brushes alone, and the reverse stayed locked until a reload
   (audit 2 Oct 2026).

   After a change (and on a return from the browser's page cache) the footer is
   asked for again; when its lock differs from the one on screen, the page
   reloads, as ns-filling.js already does on this page. An emptied basket is
   left to Dawn's own empty state. One small request per change, on /cart only. */
(function () {
  'use strict';
  var footer = document.getElementById('main-cart-footer');
  if (!footer || window.__nsCartLock) return;
  window.__nsCartLock = true;
  var sid = footer.getAttribute('data-id');
  if (!sid) return;

  function lock(root) {
    var co = root.querySelector('#checkout');
    return (co && co.disabled ? 'off' : 'on') + '|' + root.querySelectorAll('.ns-cart-brush-only').length;
  }

  var asked = 0;
  function check() {
    var mine = ++asked;
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (!html || mine !== asked) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('main-cart-footer');
        if (!next || next.classList.contains('is-empty')) return;
        var now = document.getElementById('main-cart-footer');
        if (now && lock(next) !== lock(now)) window.location.reload();
      })
      .catch(function () {});
  }

  var timer = 0;
  function later() {
    clearTimeout(timer);
    timer = setTimeout(check, 400);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, later);
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) later();
  });
})();
